<template>
  <div
      class="service-card__container"
      @click="handleClick({ id, route})"
    >
    <div class="service-card__body">
      <div class="service-card__body-icon">

      </div>
      <div class="service-card__body-content">
        <div class="service-card__body-content-header">
          <div class="service-card__body-content-header-icon">
            <img :src="`/icons/icon-${iconType}.svg`" alt="">
          </div>
          <div class="service-card__body-content-header-title">
            <h2>
              {{ title }}
            </h2>
          </div>
        </div>
        <div class="service-card__body-content-description">
          <p>
            {{ description }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
const router = useRouter();

defineProps({
  iconType: {
    type: String,
    required: true,
    default: '',
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: false,
    default: '',
  },
  id: {
    type: String,
    required: true,
    default: ''
  },
  route: {
    type: String,
    required: true,
    default: ''
  }
});

const handleClick = async (payload) => {
  switch (payload.id) {
    case '532':
      router.push('/sap');
      break;
    default:
      router.push(payload.route)
      break;
  }
}

</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Roboto", sans-serif;
}

.service-card {


    &__container, &__body-content-header, &__body-content {
      display: flex;
    }

    &__container {
      display: flex;
      width: 250px;
      min-height: 120px;
      height: auto;
      padding: 16px;
      border-radius: 16px;
      box-shadow: 0 4px 2px rgba(0,0,0, .25);
      background: #ffffff;
      color: #212121;
      align-items: center;
      justify-content: center;

      &:hover {
        cursor: pointer;
      }
    }

    &__body-content-header-title h2, &__body-content, &__body-content-description {
      font-size: 16px;
      line-height: 24px;
    }

    &__body-content {
      flex-direction: column;

      &-header {
        flex-direction: row;
        align-items: center;
        justify-items: center;
        gap: 8px;

        &-title {

          & h2 {
            width: fit-content;
            letter-spacing: 0;
          }
        }
      }

      &-description {
        max-width: 145px;
        margin-left: 36px;
        margin-top: 4px;
        color: #757575;
        font-weight: 400;
      }
    }
  }
</style>